import { TOGGLE_SEGMENT_PICKER_PINNED } from './actionTypes';

const toggleSegmentPickerPinned = isPinned => ({
    type: TOGGLE_SEGMENT_PICKER_PINNED,
    payload: isPinned,
});

export default toggleSegmentPickerPinned;
